module.exports = __webpack_public_path__ + "bb5e1f0c940c2ddbeb1d81e7c76c88c8.svg";